import { useQuery } from "@tanstack/react-query";
import { briefKeys } from "../queryKeys";
import { fetchOpenFindingsCount } from "../repository";

/**
 * How many findings await the user on the selected project's brief — the red
 * dot on the Brief nav item. `useBriefBuildingRealtime` invalidates it on
 * every findings event; the slow poll is only a fallback.
 */
export function useBriefOpenFindingsCount(
  buildingId: number | null,
  projectId: number | null,
  enabled = true
) {
  const query = useQuery({
    queryKey: briefKeys.openCount(buildingId, projectId),
    queryFn: () => fetchOpenFindingsCount(projectId as number),
    enabled: enabled && buildingId !== null && projectId !== null,
    refetchInterval: 60_000,
  });
  return { openFindingsCount: query.data ?? 0 };
}
